






















































































import { productLinkUrl, searchToWhereUrl } from '@core/utils/jump'
import { isString } from 'lodash'
import { Component, Vue, Prop, Inject } from 'vue-property-decorator'
import { getSelectedCityId, getAppointDate, isTCQZMiniprogram, cookies } from '@utils/index'
import { isRkhy } from '@/app/core/utils'
import iconUserGold from '@/assets/images/search/icon-user_gold.png'
import iconUserPregnant from '@/assets/images/search/icon-user_pregnant.png'
import iconUserCertify from '@/assets/images/search/icon-user_certify.png'

@Component({
  filters: {
    distanceStr(distance: string) {
      return +distance > 60 ? '>60' : distance
    }
  }
})
export default class BusinessItem extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: any
  @Prop({ default: 1 }) readonly type!: number //1表示普通 搜索列表样式  2表示卡片 城市站样式

  @Inject('pageTrackParams')
  pageTrackParams!: any
  @Inject('clickid_200003')
  clickid_200003!: string
  @Inject('clickid_200002')
  clickid_200002!: string
  @Inject('clickid_200001')
  clickid_200001!: string

  tcqzUerLevel = 0 //同城亲子小程序合伙人等级

  mounted() {
    isTCQZMiniprogram().then(res => {
      if (res) {
        this.tcqzUerLevel = cookies.get('dfwUserLevel')
      }
    })
  }

  goDetail({ linkUrl = '' }) {
    return productLinkUrl(linkUrl, this.type === 1 ? 3 : 5)
  }
  goDetailExposure({ spuId = '' }) {
    return `${this.clickid_200002}||${JSON.stringify({ spuid: spuId })}`
  }
  goDetailClick({ spuId = '' }) {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200002, positionParam: { spuid: spuId } })
  }
  get toShop() {
    const { isSpot, businessType, businessId } = this.value
    return searchToWhereUrl({ toShop: true, businessType, businessId, isSpot })
  }
  get toShopExposure() {
    const { businessId, storeName, businessType } = this.value
    return `${this.clickid_200001}||${JSON.stringify({ popid: businessId, name: storeName, btype: businessType })}`
  }
  toShopClick() {
    const { businessId, storeName, businessType } = this.value
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200001, positionParam: { popid: businessId, name: storeName, btype: businessType } })
  }

  get toMoreSpu() {
    const { isSpot, businessType, businessId } = this.value
    return searchToWhereUrl({ toShop: true, businessType, businessId, isSpot })
  }
  get toMoreSpuExposure() {
    const { businessId } = this.value
    return `${this.clickid_200003}||${JSON.stringify({ popid: businessId })}`
  }
  toMoreSpuClick() {
    const { businessId } = this.value
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200003, positionParam: { popid: businessId } })
  }

  get categoryName() {
    const { businessCategorys, storeCategory } = this.value
    if (storeCategory) return storeCategory
    if (businessCategorys && isString(businessCategorys)) {
      return businessCategorys.split(',').join('/')
    }
    return ''
  }

  //只存在景区 促销为空 高度才是91  其他情况都是134
  get isSpuSmallHeight() {
    return (value: any) => {
      const { promotion1 = [], promotion2 = [] } = JSON.parse(value.promotions)
      return promotion1.length === 0 && promotion2.length === 0 && +value.isSpot === 1
    }
  }

  //标签 1营销标签 promotion1 接口约定只有一个  2普通标签 promotion2 最多4个
  get promotionTag() {
    return (type: number, value: any) => {
      const { promotion1 = [], promotion2 = [] } = JSON.parse(value.promotions)
      if (type === 1) {
        const [p = ''] = promotion1
        return p
      } else {
        const result = getAppointDate(value.reserveDate, value.reserveTime, value.spuSpotEndTime)
        if (result) return [...promotion2, result]
        return promotion2
      }
      return ''
    }
  }

  get isRKHYAPP() {
    return isRkhy()
  }

  getMaxShareEarnMoney(data: any) {
    if (this.tcqzUerLevel > 0) {
      if (this.tcqzUerLevel == 1) {
        return data.commonMaxCommission || 0
      } else if (this.tcqzUerLevel == 2) {
        return data.superMaxCommission || 0
      }
    }
    const ratio = JSON.parse(data.ratio)
    if (ratio && ratio.maxShareAmount) {
      return ratio.maxShareAmount
    }
    return 0
  }

  getMinShareEarnMoney(data: any) {
    if (this.tcqzUerLevel > 0) {
      if (this.tcqzUerLevel == 1) {
        return data.commonMinCommission || 0
      } else if (this.tcqzUerLevel == 2) {
        return data.superMinCommission || 0
      }
    }
    return JSON.parse(data.ratio).minShareAmount
  }

  spuUserTag(spu: any) {
    if (spu.customerType == 1) {
      return iconUserGold
    } else if (spu.customerType == 2) {
      return iconUserPregnant
    } else if (spu.customerType == 3) {
      return iconUserCertify
    }
    return ''
  }
}
